import React from 'react';
import { 
  BookOpen, 
  ShoppingBag, 
  Store, 
  Calculator, 
  DollarSign, 
  Globe, 
  HelpCircle, 
  FileText, 
  Ruler, 
  AlertTriangle, 
  Crown, 
  Truck, 
  Headphones, 
  ShieldCheck, 
  CheckCircle2,
  Sparkles,
  ArrowRight,
  Landmark
} from 'lucide-react';
import { ROUTES, navigateTo } from '../utils/routes';

export const SitePagesNav: React.FC = () => {
  const sections = [
    {
      title: 'Páginas Principais',
      links: [
        { path: '/', label: 'Página Inicial', icon: Globe },
        { path: '/blog', label: 'Blog & Guias', icon: BookOpen, badge: 'Artigos' },
        { path: '/personal-shopper', label: 'Personal Shopper', icon: ShoppingBag, badge: 'Compras' },
        { path: '/loja', label: 'Loja Do Japão', icon: Store, badge: 'Pronta Entrega' },
        { path: '/planos', label: 'Planos VIP', icon: Crown, badge: 'VIP' }
      ]
    },
    {
      title: 'Serviços & Tarifas',
      links: [
        { path: '/servicos-e-precos', label: 'Tabela de Serviços & Preços', icon: DollarSign, badge: '2026' },
        { path: '/calculadora-frete', label: 'Calculadora de Frete Internacional', icon: Calculator, badge: 'Simulador' },
        { path: '/simulador-de-impostos', label: 'Simulador Oficial de Impostos no Brasil', icon: Landmark, badge: 'II + ICMS' },
        { path: '/rastreamento', label: 'Rastreamento de Encomendas', icon: Truck },
        { path: '/formas-de-pagamento', label: 'Formas de Pagamento (PIX & Cartão)', icon: ShieldCheck }
      ]
    },
    {
      title: 'Guias de Compras & Tutoriais',
      links: [
        { path: '/mercari', label: 'Como Comprar no Mercari Japan', icon: ShoppingBag },
        { path: '/leilao-yahoo-japan', label: 'Leilões do Yahoo! Japan (Yafuoku)', icon: Sparkles },
        { path: '/tabela-de-tamanhos', label: 'Tabela de Tamanhos (Roupas & Calçados)', icon: Ruler },
        { path: '/impostos-de-compra-e-importacao', label: 'Impostos e Alfândega no Brasil', icon: FileText },
        { path: '/produtos-proibidos-ou-perigosos', label: 'Produtos Proibidos ou Restritos', icon: AlertTriangle },
        { path: '/sites-de-compras', label: 'Melhores Sites de Compras no Japão', icon: Globe }
      ]
    },
    {
      title: 'Institucional & Suporte',
      links: [
        { path: '/sobre', label: 'Sobre a Do Japão & Armazém', icon: HelpCircle },
        { path: '/como-funciona', label: 'Como Funciona o Redirecionamento', icon: CheckCircle2 },
        { path: '/contato', label: 'Fale Conosco & Atendimento', icon: Headphones },
        { path: '/faq', label: 'Perguntas Frequentes (FAQ)', icon: HelpCircle }
      ]
    }
  ];

  return (
    <nav aria-label="Mapa de Páginas do Site" className="bg-slate-900 text-white py-12 px-4 sm:px-6 lg:px-8 border-t border-slate-800">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 pb-8 mb-8 border-b border-slate-800">
          <div>
            <span className="text-xs font-black uppercase tracking-widest text-[#E63946] flex items-center gap-1.5 mb-1">
              <Sparkles className="w-3.5 h-3.5" />
              <span>Diretório Oficial de Páginas</span>
            </span>
            <h3 className="text-xl sm:text-2xl font-black text-white">
              Navegue por Todas as Páginas da Do Japão
            </h3>
            <p className="text-xs sm:text-sm text-slate-400 mt-1 max-w-2xl">
              Acesse diretamente tutoriais, simulador de frete, catalogo de compras assistidas e atendimento com a equipe em Saitama.
            </p>
          </div>
          <div className="text-xs text-slate-400 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span>
            <span>URLs Canônicas Indexáveis &middot; 200 OK</span>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {sections.map((sec, sIdx) => (
            <div key={sIdx} className="space-y-3">
              <h4 className="text-xs font-black uppercase tracking-wider text-slate-300 flex items-center gap-2">
                <span className="w-1.5 h-3.5 bg-[#E63946] rounded-xs"></span>
                <span>{sec.title}</span>
              </h4>
              <ul className="space-y-2">
                {sec.links.map((link, lIdx) => {
                  const Icon = link.icon;
                  return (
                    <li key={lIdx}>
                      <a
                        href={link.path}
                        onClick={(e) => {
                          if (!e.metaKey && !e.ctrlKey) {
                            e.preventDefault();
                            navigateTo(link.path);
                          }
                        }}
                        className="group flex items-center justify-between text-xs text-slate-400 hover:text-white py-1.5 px-2 rounded-lg hover:bg-slate-800/80 transition-all"
                      >
                        <div className="flex items-center gap-2">
                          <Icon className="w-3.5 h-3.5 text-slate-500 group-hover:text-amber-400 transition-colors" />
                          <span className="group-hover:translate-x-0.5 transition-transform">
                            {link.label}
                          </span>
                        </div>
                        {link.badge && (
                          <span className="px-1.5 py-0.5 text-[9px] font-black uppercase rounded bg-slate-800 group-hover:bg-[#E63946] text-slate-300 group-hover:text-white transition-colors">
                            {link.badge}
                          </span>
                        )}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </nav>
  );
};
